
<template>
  <div id="chart">
    <apexchart 
      :type="tipoGrafico" 
      :options="opcoesGrafico" 
      :series="series"
      v-bind="$attrs"
      :height="height"
      @click="clickEmit"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: "SGPGraficoComponent",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    tipoGrafico: {
      type: String,
      required: true
    },
    opcoesGrafico: {
      type: Object,
      required: true
    },
    series: {
      type: Array,
      required: true
    },
    height: {
      type: String,
      required: false,
      default: "200"
    }
  },
  
  methods: {
    clickEmit(event, chartContext, opts) {
      this.$emit('sgpGraficoEmit', opts)
    }
  }
}
</script>